<ng-container>
    <div mat-dialog-title>
        <h2>{{"availabilty.Configure Slots" | translate}}</h2>
        <button mat-icon-button class="close" (click)="openConfirmDialog()">
            <mat-icon class="pop-close">close</mat-icon>
        </button>
    </div>
        <div class="mat-dialog-head">
            <span class="font-18 grey-color fontRegular">{{"availabilty.Day to config its time slots" | translate}}</span>
            <span class="ml-2 font-18 fontMedium"> {{data.record.name}}</span>
        </div>
        <mat-dialog-content class="pt-0 pb-0 mt-3 slots-select-list">
            <div class="mat-dialog-body">
                <div class="row">
                    <div class="col-sm-12 mb-4 mt-3">
                        <div class=" d-flex align-items-center">
                            <!-- <span class="font-16 fontRegular">{{'restaurant.Slots' | translate}}</span> -->
                            <a class="font-14 fontRegular grey-color ml-auto preventSelection"
                              (click)="selectAllSlots()"> <span *ngIf="!isSelected">
                                {{'availabilty.Select All Slots' | translate}}</span>
                              <span *ngIf="isSelected">{{'availabilty.Unselect All Slots' | translate}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <mat-selection-list class="circle-selection-list text-left"
                    [formControl]="hours">
                    <ng-container *ngFor="let item of workingSlots; index as index">
                        <div class="d-inline-block">
                            <mat-list-option class="mb-2" [value]="item"
                                checkboxPosition="before"
                                [(selected)]="item.isActive">
                                {{item.timefrom}}
                            </mat-list-option>
                        </div>
                    </ng-container>
                </mat-selection-list>
                <div class="grey-list-items form-group mt-3">
                    <div class="list-item sub-list-item-dashed">
                        <div class="d-flex align-items-center">
                            <p class="mr-3 grey-color info font-14">{{"availabilty.Unselected slots will be hidden while reservation by guests or host" | translate }}
                            </p>
                        </div>
                    </div>
                </div>


            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
            <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading"
                [class.loading]="loading">
                {{"forms.Save" | translate}}
            </button>
        </mat-dialog-actions>
</ng-container>
